import { createContext, useState, useEffect, useReducer } from "react";
import API from "api/api";
import { getCEmails } from "api/cemail";
// import { formatPersonal, formatFactors } from "utils/formatters";
import { formatPersonal } from "utils/formatters";

const AppContext = createContext();

const AppProvider = ({ user, children }) => {
    const [personal, setPersonal] = useState({}); // readOnly personal info
    const [account, dispatch] = useReducer(reducer, {});
    const [cEmails, setCEmails] = useState([]);
    const [userSession, setUserSession] = useState([]);
    const [loadingCEmails, setLoadingCEmails] = useState(false);
    const [phoneData, setPhoneData] = useState([]);

    const fetchProfileData = async () => {
        try {
            const { userProfile, profileFactors } = await API.getSecurityProfile();
            setPersonal(formatPersonal(userProfile));
            const accountInfo = {
                primaryEmail: userProfile.profile.email.toLowerCase(),
                secondaryEmail: userProfile?.profile?.secondEmail?.toLowerCase(),
                factors: profileFactors
                // factors: formatFactors(profileFactors)
            };
            dispatch({ type: "INIT", payload: accountInfo });
            getPhoneFactor(profileFactors);
        } catch (err) {
            console.error("Error from GetSecurityPofile", err);
        }
    };

    const getPhoneFactor = (data) => {
        const phoneDataNew = [];
        if (data.length > 0) {
            data.forEach(({ factorType, id, status, profile }) => {
                if (factorType === "phone") { 
                    phoneDataNew.push({ id: id, status: status, number: profile.phoneNumber })
                } 
            });
           setPhoneData([...phoneDataNew]);
        }
    }

    const fetchCEmails = async () => {
        setLoadingCEmails(true);
        const { data } = await getCEmails();
        setLoadingCEmails(false);
        setCEmails(data);
    };

    const fetchUserSessionData = async () => {
        try {
            const userData  = await API.getUserSessionData();
            setUserSession(userData);
        } catch (err) {
            console.error("Error from getUserSessionData", err);
        }
    };

    useEffect(() => {
        fetchProfileData();
        fetchCEmails();
        fetchUserSessionData();
    }, []);

    return (
        <AppContext.Provider
            value={{
                personal,
                account,
                dispatch,
                fetchProfileData,
                user,
                userSession,
                fetchUserSessionData,
                cEmails,
                setCEmails,
                fetchCEmails,
                loadingCEmails,
                phoneData, 
                setPhoneData
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export { AppProvider, AppContext };

/**
 *
 * @param {Object} state: account state
 * @param {Object} action: a object of type and payload
 * @returns
 */
function reducer(state, action) {
    switch (action.type) {
        case "INIT":
            return action.payload;
        case "USER":
            return action.payload
        case "CONTACT":
            return { ...state, ...action.payload };
        case "FACTOR":
            return {
                ...state,
                factors: {
                    ...state.factors,
                    ...action.payload
                }
            };
        default:
            throw new Error(`Unhandled action type ${action.type}`);
    }
}